/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://b4pyflob4fgbbpo6ie4kepmmmu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-hpd4ec6itra7dphwobutvsiiri",
    "aws_cognito_identity_pool_id": "us-east-1:c9dfa3b2-d528-4c4c-a7ef-c005d09f35b0",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_j94sQdmck",
    "aws_user_pools_web_client_id": "6b661bq8mchsa46a50otqobqjp",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
